var map = {
	"./arrow-down.svg": 39,
	"./arrow-grey.svg": 40,
	"./arrow-white-up.svg": 41,
	"./black-arrow.svg": 42,
	"./blue-check.svg": 43,
	"./boost-icon.svg": 44,
	"./check.svg": 45,
	"./clean-map-big.svg": 46,
	"./clean-map-small.svg": 47,
	"./green-sale.svg": 48,
	"./grey-check.svg": 49,
	"./groups.svg": 50,
	"./price.svg": 51,
	"./question.svg": 52,
	"./redaction.svg": 53,
	"./rocket.svg": 54,
	"./sale.svg": 55,
	"./success.svg": 56,
	"./unchecked.svg": 57
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38;